import { getCurrentSystem } from '@umu/ukit-lang';
import { useEffect, useState } from 'react';
import { getAccountPlanSurfaceList, ISurfacePricing } from '@umu/umu-api';
import { handleHookError } from 'common/utils/errorHandler';
const system = getCurrentSystem();
const packageType = system === 'CN' ? 1 : 2;

export const useSurfacePricing = (plan_ids = '2,3', package_type = packageType) => {
    const [surfacePricing, setSurfacePricing] = useState<{ [key: string]: ISurfacePricing } | null>(null);
    useEffect(() => {
        getAccountPlanSurfaceList({
            plan_ids,
            package_type,
        })
            .then((res) => {
                if (!res.error_code) {
                    setSurfacePricing(res.data);
                }
            })
            .catch((error: unknown) => {
                handleHookError(error, 'useSurfacePricing', { plan_ids, package_type });
            });
    }, []);

    return surfacePricing;
};
